import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://ysoknnrcftkegbpkwxjp.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inlzb2tubnJjZnRrZWdicGt3eGpwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU2OTcwNTYsImV4cCI6MjA3MTI3MzA1Nn0.Uq_t34BJFxVGgzcoaRE8oPqxZ2P6HHemEDB0Ox-beQ0'

if(SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})